export type HttpErrorDetails = {
	statusCode: number;
	message: string;
	traceId: string | undefined;
	originalResponse: Response;
};

/** Internal response normalization for the gated shared transport. */
export function getHttpErrorDetails(response: Response): HttpErrorDetails | undefined {
	if (response.ok) {
		return undefined;
	}
	// Match Jira's first-present-header precedence, including an empty atl-traceid.
	const header = ['atl-traceid', 'x-trace-id'].find((name) => response.headers.has(name));
	return {
		statusCode: response.status,
		message: `Error server response: ${response.status}`,
		traceId: header === undefined ? undefined : response.headers.get(header) || undefined,
		originalResponse: response,
	};
}
